var map = {
	"./badge_proofpoints-dark.de.html": [
		578,
		959
	],
	"./badge_proofpoints-dark.en.html": [
		56,
		56
	],
	"./badge_proofpoints-dark.es.html": [
		819,
		819
	],
	"./badge_proofpoints-dark.fr.html": [
		691,
		691
	],
	"./badge_proofpoints-dark.nl.html": [
		373,
		373
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 51;
module.exports = webpackAsyncContext;